<template>
    <div>
        <footer class="footer">
            <div class="container-fluid">
                <!-- <nav class="pull-left">
                    <ul class="nav">
                        <li class="nav-item">
                            <a class="nav-link" href="#">
                                ThemeKita
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="#">
                                Help
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="#">
                                Licenses
                            </a>
                        </li>
                    </ul>
                </nav> -->
                <div class="copyright ml-auto">
                    2019, made with <i class="fa fa-heart heart text-danger"></i> by <a href="">Diskominfo-Sandi Kab. Konsel</a>
                </div>				
            </div>
        </footer>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
